// extracted by mini-css-extract-plugin
export var dataCell = "_h9-2";
export var dataRow = "_h9-0";
export var headerRow = "_h9-1";